const waitForSeconds = <T>(numOfSeconds: number, output?: T): Promise<undefined | T>=>
    new Promise((res, rej)=>
        setTimeout(()=>res(output), 1000 * numOfSeconds));
export default waitForSeconds;